import "./Consent.css";
import ReactGA from "react-ga4";
import Cookies from "js-cookie";
import React, {useEffect} from "react";
import CookieConsent, {OPTIONS} from "react-cookie-consent";

const gaTrackingId = "G-KRVJG4LMSD";

function ConsentDialog() {
    useEffect(() => {
        // Disable scrolling on mount
        if (!Cookies.get("consent")) {
            document.body.style.overflow = "hidden";
        }

        // Cleanup: restore scrolling if component unmounts unexpectedly
        return () => {
          document.body.style.overflow = "unset";
        };
    }, []);

    return (
        <CookieConsent
            location={OPTIONS.TOP}
            buttonText="Agree"
            declineButtonText="Decline"
            enableDeclineButton
            setDeclineCookie={false}
            // Outer container style
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",       // Center the text
              background: "#1F2937",
              padding: "1rem"
            }}
            // Inner content style
            contentStyle={{
              margin: 0,
              padding: 0,
              maxHeight: "200px",
              maxWidth: "600px"
            }}
            // Button style
            buttonStyle={{
              marginTop: "1rem",
              backgroundColor: "#1F2937",
              borderRadius: "5px",
              border: "solid 1px #FF5800",
              color: "#fff",
              fontSize: "1rem",
              textAlign: "center",
              padding: "0.5rem 1rem"
            }}
            // Styles for the Decline button
            declineButtonStyle={{
                marginTop: "1rem",
                backgroundColor: "#1F2937",
                borderRadius: "5px",
                border: "solid 1px #FF5800",
                color: "#fff",
                fontSize: "1rem",
                textAlign: "center",
                padding: "0.5rem 1rem"
            }}
            cookieName="consent"
            onAccept={() => {
                // Re-enable scrolling once consent is accepted
                document.body.style.overflow = "unset";
                // Initialize GA if it hasn't been initialized already
                if (!window.gaInitialized) {
                    ReactGA.initialize(gaTrackingId);
                    window.gaInitialized = true;
                }
                // Add Google Analytics
                ReactGA.event({
                    category: "CookieConsent",
                    action: "Consent Accepted"
                });
            }}
            onDecline={() => {
                // When declining, do not set any cookies or initialize GA.
                // Simply redirect the user to Google.
                window.location.href = "https://www.google.com";
            }}
        >
            <div style={{ margin: 0 }}>
                Hey there! By using <span className="colored">self-affirmations.net</span>, you're saying you're cool with the{" "}
                <a href="/terms" className="colored-underline">
                Terms & Conditions
                </a>{" "}
                and{" "}
                <a href="/privacy" className="colored-underline">
                Privacy Policy
                </a>. We use a tiny cookie to remember your consent so you can enjoy your self-affirmations hassle-free. If that sounds good, click "Agree" to get started. Thanks for being awesome!
            </div>
        </CookieConsent>
    );
}

export default ConsentDialog;
